import {CApi as adminGwApi} from '@services/api';

export async function getSuppliersDictionary() {
    const response = await adminGwApi().webSupplier.webSupplierList({
        limit: 200,
        offset: 0
    });

    // Превращаем массив в объект { [code]: name }
    return (response.data.items || []).reduce(
        (acc: Record<string, string>, item: {code: string; name: string}) => {
            acc[item.code] = item.name;
            return acc;
        },
        {}
    );
}
